import createSagaMiddleware from 'redux-saga';
import { configureStore } from '@reduxjs/toolkit';

import rootSaga from './sagas';
import rootReducer from './reducers';
import { setSessionExpiredHandler } from '../lib/session';
import { sessionExpired, initializeAuth } from './slices/auth';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

// The axios interceptor runs outside React and must not import the store, so the store
// hands it a dispatcher instead.
setSessionExpiredHandler(() => store.dispatch(sessionExpired()));

// Seed auth from localStorage before first render so ProtectedRoute never sees a logged-out flash.
store.dispatch(initializeAuth());

export default store;
